import { guideSteps } from "@/mocks/manhwaData";

export default function Guide() {
  return (
    <section id="guide" className="relative overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-primary-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-secondary-500/20 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-100 ring-1 ring-background-50/20">
            <i className="ri-compass-3-line"></i>
            使用指南
          </span>
          <h2 className="mt-3 font-heading text-2xl text-background-50 md:text-3xl">三步搞定韩漫追更</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-background-100/70">
            从收藏本站到直达阅读页，轻轻松松开始你的韩漫之旅。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step) => (
            <article
              key={step.id}
              className="rounded-lg border border-background-50/10 bg-background-50/5 p-6 transition-colors hover:border-primary-400/40"
            >
              <span className="font-heading text-3xl text-primary-400">{step.num}</span>
              <h3 className="mt-3 text-base font-bold text-background-50">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/70">{step.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}